/**
 * @typedef {Object} Data
 * @property {number} id
 * */

/**
 * @param {Array<Data>} data
 *
 * @return {Array<Data>}
 * */
export default function reduceUnique(data) {
  const uniqueIds = new Set();

  return data.reduce((acc, value) => {
    if (uniqueIds.has(value.value)) return acc;
    uniqueIds.add(value.value);
    acc.push(value);

    return acc;
  }, []);
}
